import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchCoursesByIdAsync = createAsyncThunk(
  'courses/fetchCoursesByIdAsync',
  async url => {
    const res = await axios.get(url);
    return res.data;
  }
);

const courseByIdSlice = createSlice({
  name: 'coursesById',
  initialState: {
    courses: {},
    load: false,
    error: false
  },
  reducers: {
    addCourses: (state, { payload }) => {
      state.courses = payload;
      state.load = false;
    }
  },

  extraReducers: {
    [fetchCoursesByIdAsync.pending]: state => {
      state.load = true;
    },
    [fetchCoursesByIdAsync.fulfilled]: (state, { payload }) => {
      state.courses = payload;
      state.load = false;
    },
    [fetchCoursesByIdAsync.rejected]: (state, { payload }) => {
      state.error = payload;
      state.load = false;
    }
  }
});
export const getCourseAsync = state => state.courses.courses;
export default courseByIdSlice.reducer;
